import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Switch } from 'types';

export const getSwitches = async (): Promise<Switch[]> => {
  const { data } = await axios.get(`/api/switches`);
  return data as Switch[];
};

type QueryFnType = typeof getSwitches;

type UseSwitchesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSwitches = ({ config }: UseSwitchesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['switches'],
    queryFn: getSwitches,
    ...config,
  });
};
